import { PropsWithChildren, CSSProperties, FC } from 'react'
import { Tag } from 'antd'
import { EXCEPTION_STATUS } from '@ProdWb/constants'
import { TAG_COLORS } from '@OpsWb/constants'

import { getExceptionTypeTag } from '../ExceptionFailureList/logic'

export type ExceptionTypeTagPropsType = {
    type?: string
    assignedTo: string | null
    milestone: string | null
    exceptionStatus?: string | null
    customerAffected?: boolean | null
    style?: CSSProperties
    showOnDetails?: boolean
}

const ExceptionTypeTag: FC<
    PropsWithChildren<ExceptionTypeTagPropsType>
> = props => {
    const { exceptionStatus, style, customerAffected, showOnDetails } = props
    const getTagColor = () => {
        switch (exceptionStatus) {
            case EXCEPTION_STATUS.OPEN_FAILURE:
                return TAG_COLORS.RED
            case EXCEPTION_STATUS.OPEN_EXCEPTION:
                return TAG_COLORS.ORANGE
            default:
                return ''
        }
    }

    const tagTitle = getExceptionTypeTag(props)

    return exceptionStatus ? (
        <>
            <Tag color={getTagColor()} style={style}>
                {tagTitle}
            </Tag>
            {showOnDetails && <br />}
            {customerAffected && (
                <Tag color={getTagColor()} style={style}>
                    Customer affected
                </Tag>
            )}
        </>
    ) : null
}

export default ExceptionTypeTag
